import api from "~services/axios";

export default {
  /**
   * 几个API接口是同一个，区分是code参数不同
   * */
  // 获取客户类型
  apiGetProjectStatus: params =>
    api.get("/api/common/query/category", { params }),
  // 获取客户类型   code相同
  apiGetCustomType: params => api.get("/api/common/query/category", { params }),
  // 获取联系人状态
  apiGetContactsType: params =>
    api.get("/api/common/query/category", { params }),
  // 获取拜访方式
  apiGetVisitType: params => api.get("/api/common/query/category", { params }),
  // 获取拜访联系人
  apiGetProductList: params =>
    api.get("/api/common/query/category", { params }),
  // 获取医生职称
  apiGetDoctorTitle: params =>
    api.get("/api/common/query/category", { params }),
  // 获取医院等级
  apiGetHospitalLevel: params =>
    api.get("/api/common/query/category", { params }),
  // 获取产品线列表 和 申请类型 => 审核模块
  apiGetServiceLines: params =>
    api.get("/api/common/query/category", { params }),
  // 数据字典
  apiGetCategory: params => api.get("/api/common/query/category", { params }),
  // 客户等级
  apiGetCustomerLevel: params =>
    api.get("/api/common/query/category", { params }),

  // 获取项目名称
  apiGetProjectName: params => api.get("/api/common/query/project", { params }),

  // 获取客户名称
  apiGetCustomName: params => api.get("/api/work/project/about", { params }),

  // 获取用户部门teamId
  apiGetUserTeamId: params => api.get("/api/common/query/team", { params }),

  // 获取拜访联系人
  apiGetVisitPeople: params => api.get("/api/work/project/about", { params }),

  // 联想查询用户
  apiGetUser: params => api.get("/api/common/query/user", { params }),

  // 获取用户权限
  apiGetAdmin: params => api.post("/api/common/auth", params),

  // 获取首页审核列表
  apiGetHomeAuditiongList: params =>
    api.get("/api/home/page/approve", { params }),

  // 获取首页申请列表
  apiGetHomeApllyList: params => api.get("/api/home/page/apply", { params }),

  // 获取客户列表
  apiGetHomeCustomList: params => api.post("/api/crmcustomer/query", params),

  // 获取业务员列表
  apiGetClerkList: params => api.get(
    `/api/${
        params?.sourcePart === "medicalCus"
          ? "crmMedicalCustomer"
          : "crmcustomer"
    }/query/teamuser`,
    { ...params },
  ),
  // 获取签到团队
  apiGetSigninTeams: params =>
    api.get("/api/signin/querysigninteam", { params }),

  // 上传名片
  apiUploadBusinessCard: (params, config) =>
    api.post("/api/common/identifyCard", params, config),
  // 获取产品线下拉框（商机查询列表用）
  queryProductLineListForSearch: params =>
    api.get("/api/common/queryProductLineListForSearch", { params }),
};
